<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6L8 10L4 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
